export const ACTIONS_INBOUND_EMAIL_LOG = {
  INVALIDATE: 'INBOUND_EMAIL_LOGS_INVALIDATE',
  RECEIVE: 'INBOUND_EMAIL_LOGS_RECEIVE',
  DELETE: 'INBOUND_EMAIL_LOG_DELETE',
  UPDATE: 'INBOUND_EMAIL_LOG_UPDATE',
};

const inboundEmailLogConstants = {};

export default inboundEmailLogConstants;
